import { useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';
import { FilterFromUrlResponseType } from 'types/commons';
import { getFilterFromSearchParams } from 'utils/tools';

export const useGetFilter = (): {
  filter: FilterFromUrlResponseType;
  searchParams: URLSearchParams;
  setSearchParams: (params: URLSearchParams) => void;
} => {
  const [searchParams, setSearchParams] = useSearchParams();  
  const filter = useMemo(
    () => getFilterFromSearchParams(paramsToObject(searchParams.entries())),
    [searchParams],
  );
  return { filter, searchParams, setSearchParams };
};

function paramsToObject(entries) {
  const result = {};
  for (const [key, value] of entries) {
    result[key] = value;
  }
  return result;
}
